<template>
  <div class="icon-with-card">
    <div class="title">
      <div class="icon">
        <img :src="icon"
             alt="icon"
             class="icon-image">
      </div>
      <div class="title-text">
        {{title}}
      </div>
    </div>
    <div class="content">
      {{content}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'IconTitleCard',
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  }
}
</script>

<style scoped>
.title {
  display: flex;
  width: 358px;
  /* align-items: center; */
  margin-bottom: 20px;
  border-bottom: 1px solid #dfc6b2;
  padding: 15px 0;
}

.content {
  text-align: left;
  font-size: 16px;
  line-height: 30px;
  color: #634c37;
}

.icon{
    display: flex;
    justify-content: center;
    align-items: center;
}

.icon-image {
  height: 25px;
  /* margin-right: 20px; */
}

.title-text {
  font-size: 22px;
  font-weight: bold;
  color: #9e5c1d;
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/IconTitleCard.vue